import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Search } from 'lucide-react';
import { MdPrint } from "react-icons/md";
import classes from "./FixedArea.module.css";
import plus from  "../../../Assets/plus.svg"
import { FaEdit, FaPen } from 'react-icons/fa';
// import DeleteIcon from "../../../../Assets/new-delete.svg"
import { Spinner, Badge, Button, Modal, Form, Alert, Table } from 'react-bootstrap';
import HeaderNav from "../../Accoungting/HeaderNav/FixedAssetNav";
import axios from "axios";
import { BASE_URL, TOKEN, BASE_URL1 } from "../../../Components/Styles/API/API";
// "../../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
// import ToggleSlider from "./ToggleSlider";
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"

const FixedAssetArea = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [permId, setPermId] = useState([]);
  const [roleID, setRoleID] = useState([]);
  const [permLoading, setPermLoading] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [toggleStates, setToggleStates] = useState({});
  const [roleStates, setRoleStates] = useState({});
  const [checkAll, setCheckAll] = useState(false);
  const [roleCheckAll, setRoleCheckAll] = useState(false);
  const [roleLoading, setRoleLoading] = useState(false);
  const [userTypes, setUserTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const [error, setError] = useState("");
  const [modalError, setModalError] = useState("");
  const [success, setSuccess] = useState("");
  const [bearer, setBearer] = useState('');
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [perPage, setPerPage] = useState(10);
  const [totalUsers, setTotalUsers] = useState(0);
  const [selectedType, setSelectedType] = useState("");
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState("");
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState("");
  const [phone1, setPhone1] = useState("");
  const [selectedRole1, setSelectedRole1] = useState("");
  const [phone, setPhone] = useState("");
  const [userType, setUserType] = useState([]);
  const [zones, setZones] = useState([]);

  // Main filter states
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [provinces, setProvinces] = useState([]);
  const [provLoading, setProvLoading] = useState(false);

  // React Select states for filters
  const [selectedContinent, setSelectedContinent] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [contLoading, setContLoading] = useState(false);
  const [regionLoading, setRegionLoading] = useState(false);

  // React Select states for modal
  const [selectedContinentModal, setSelectedContinentModal] = useState(null);
  const [selectedRegionModal, setSelectedRegionModal] = useState(null);
  const [selectedProvinceModal, setSelectedProvinceModal] = useState(null);
  const [regionsModal, setRegionsModal] = useState([]);
  const [provincesModal, setProvincesModal] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  // const [totalEntries, setTotalEntries] = useState("");
  // const [totalPages, setTotalPages] = useState(1);
  const [areaLoad, setAreaLoad] = useState(false);
  const [areas, setAreas] = useState([]);

  const [responseData, setResponseData] = useState([]);
  const [selectedZone, setSelectedZone] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [selectedArea1, setSelectedArea1] = useState('');
  const [continentID, setContinentID] = useState(null);
  const [regionID, setRegionID] = useState(null);
  const [provinceID, setProvinceID] = useState(null);
  const [processLoading, setProcessLoading] = useState(false);
  const [eyeClicked, setEyeClicked] = useState(false);
  const [trashClicked, setTrashClicked] = useState(false);
  const [description, setDescription] = useState('')
  const [description1, setDescription1] = useState('')
  const [selectedZone1, setSelectedZone1] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [continent, setContinent] = useState('');
  const [createLoading, setCreateLoading] = useState(false);
    const [continentName, setContinentName] = useState("");
  const [provinceName, setProvinceName] = useState("");
  const [regionName, setRegionName] = useState("");

 
  // Print View handler
  const handlePrintView = () => {
    navigate('/budget/charts_of_account/User');
  };

  // Pagination handlers
  const handleFirstPage = () => {
    if (currentPage > 1) {
      // fetchUsers(1);
    }
  };

  const handleLastPage = () => {
    if (currentPage < totalPages) {
      // fetchUsers(totalPages);
    }
  };

  const handlePageClick = (page) => {
    if (page !== currentPage) {
      // fetchUsers(page);
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, currentPage + 2);

      if (currentPage <= 3) {
        endPage = maxVisiblePages;
      }
      if (currentPage >= totalPages - 2) {
        startPage = totalPages - maxVisiblePages + 1;
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  };

  // Get token from localStorage
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value4 = await localStorage.getItem('provinceID');
      const value5 = await localStorage.getItem('regionID');
      const value6 = await localStorage.getItem('continentID');
            const cname = await localStorage.getItem('continent');
      const rname = await localStorage.getItem('region');
      const pname = await localStorage.getItem('province');
      
      if (value !== null) {
        setBearer(value);
      }
      if (value4 !== null) {
        setProvinceID(value4);
      }
      if (value5 !== null) {
        setRegionID(value5);
      }
      if (value6 !== null) {
        setContinentID(value6);
      }
      if (cname !== null) {
        setContinentName(cname);
      }
      if (pname !== null) {
        setProvinceName(pname);
      }
      if (rname !== null) {
        setRegionName(rname);
      }
    } catch (e) {
      console.error('Failed to fetch token from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  // Auto-fetch users when filters change
  useEffect(() => {
    if (bearer) {
      setCurrentPage(1);
      // fetchUsers(1);
    }
  }, [selectedContinent, selectedRegion, selectedProvince, bearer]);

 

  const handleCloseCreateUserModal = () => {
    setShowCreateUserModal(false);
    // resetNewUserForm();
  };

  const handleShowCreateUserModal = () => {
    setShowCreateUserModal(true);
    setModalError("");
  };


  // Skeleton loader
  const SkeletonLoader = () => {
    return (
      <>
        {Array.from({ length: 5 }).map((_, index) => (
          <tr key={index}>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '30px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '120px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '150px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div></td>
            {/* <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td> */}
            <td className={classes.btnAction}>
              <div style={{ display: 'flex', gap: '10px' }}>
                <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
                <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
              </div>
            </td>
          </tr>
        ))}
      </>
    );
  };




  const createZones = async () => {
    setCreateLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL1}/areas/create_by_province`,  
        {
          description: description,
          province_name: provinceName,
          zone_id: selectedZone
        },
        {
          headers: {
            'Authorization': `Bearer ${TOKEN}`, 
            'Content-Type': 'application/json',
          },
        }
      );
      handleCloseCreateUserModal();
      // handleProcess();
      fetchArea();
      
      // Show success toast with response message
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
  
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      
      // Check and handle specific error message
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        // toast.error(errorMessage);
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(errorMessage),
        });
        console.log(errorMessage);
      }
    } finally {
      setCreateLoading(false);
    }
  };

  const fetchZone = async () => {
    setIsLoading(true);
    try {
      // /provinces/getazoneprovince
      const response = await axios.get(`${BASE_URL1}/provinces/get_zones_by_name`, 
         {
                    params: {
                    page: currentPage,
                    // region_id: regionName,
                    province_id: provinceName,
                    // continent_id: continentName
                    },
                    headers: {
                      'Authorization': `Bearer ${TOKEN}`,
                      'Content-Type': 'application/json',
                    },
                  });

      // console.log(response);
      const zones = response.data?.data;
      const formattedZones = zones.map(item => ({
        value: item.id,
        label: item.description,
      }));
      setZones(formattedZones);
      // console.log(results);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                if (typeof error.response.data.message === 'string') {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join('; ');
                } else if (typeof error.response.data.message === 'object') {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
            }
      setZones([]);
    } finally {
      setIsLoading(false);
    }
  };

 
  const fetchAllAreas = async (selectedZone) => {
    setAreaLoad(true);
    try {
      const response = await axios.get(
        `${BASE_URL1}/zones/getareaszone?zone_id=${selectedZone}`,
        {
          headers: {
            'Authorization': `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      const areaList = response.data?.data || [];
      const formatted = areaList.map((item) => ({
        label: item.description,
        value: item.id,
      }));
  
      setAreas(formatted);
  
    } catch (error) {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
            }
          }
      setAreas([]);
    } finally {
      setAreaLoad(false);
    }
  };
  

  useEffect(() => {
    if (TOKEN && selectedZone) {
      fetchAllAreas(selectedZone);
    }
  }, [TOKEN, selectedZone]);

  // const handleProcess = async () => {
  //   setProcessLoading(true);

  //   try {
  //     const response = await axios.get(`${BASE_URL1}/zones/getareaszone`, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${TOKEN}`
  //       },
  //       params: {
  //         zone_id: selectedZone || '',
  //       }
  //     });

  //     const results = response.data?.data;
  //     setTableData(results);
  //     const resultx = response.data?.data?.total;
  //     // setTotalEntries(resultx);
  //     const total = response.data?.data?.last_page || 1;
  //     // setTotalPages(total);

  //     Swal.fire({
  //       icon: 'success',
  //       title: 'Successful',
  //       text: response.data.message,
  //     });
  //   } catch (error) {
  //     let errorMessage = 'An error occurred. Please try again.';
  //     if (error.response && error.response.data) {
  //       if (typeof error.response.data.message === 'string') {
  //         errorMessage = error.response.data.message;
  //       } else if (Array.isArray(error.response.data.message)) {
  //         errorMessage = error.response.data.message.join('; ');
  //       } else if (typeof error.response.data.message === 'object') {
  //         errorMessage = JSON.stringify(error.response.data.message);
  //       }
  //     }

  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Failed',
  //       text: errorMessage,
  //     });
  //   } finally {
  //     setProcessLoading(false);
  //   }
  // };

  // const fetchArea = async () => {
  //   setAreaLoad(true);
  //   try {
  //     const response = await axios.get(`${BASE_URL1}/provinces/getareaprovince`,    {
  //       headers: {
  //         'Authorization': `Bearer ${TOKEN}`,
  //         'Content-Type': 'application/json',
  //       },
  //     });

  //     // console.log(response);
  //     const areResult = response.data?.data;
  //     setTableData(areResult);
  //     // console.log(response);
  //   } catch (error) {
  //     if (error.response && error.response.status === 401) {
  //       // Redirect to login page if unauthorized
  //       navigate('/login');
  //     }else{
  //       let errorMessage = 'An error occurred. Please try again.';
  //       if (error.response && error.response.data && error.response.data.message) {
  //           if (typeof error.response.data.message === 'string') {
  //               errorMessage = error.response.data.message;
  //           } else if (Array.isArray(error.response.data.message)) {
  //               errorMessage = error.response.data.message.join('; ');
  //           } else if (typeof error.response.data.message === 'object') {
  //               errorMessage = JSON.stringify(error.response.data.message);
  //           }
  //       }
  //     setTableData([]);
  //     }
  //   } finally {
  //     setAreaLoad(false);
  //   }
  // };

    const fetchArea = async () => {
    setAreaLoad(true);
    try {
      const response = await axios.get(`${BASE_URL1}/provinces/get_areas_by_name`, 
            {
            params: {
            page: currentPage,
            // region_id: regionName,
            province_id: provinceName,
            // continent_id: continentName
            },
            headers: {
              'Authorization': `Bearer ${TOKEN}`,
              'Content-Type': 'application/json',
            },
          });

      // console.log(response);
      const areResult = response.data?.data;
      setTableData(areResult);
      // console.log(response);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      }else{
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
                errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
                errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
                errorMessage = JSON.stringify(error.response.data.message);
            }
        }
      setTableData([]);
      }
    } finally {
      setAreaLoad(false);
    }
  };

  useEffect(() => {
    if (
      TOKEN  && provinceName) {
      fetchArea();
      fetchZone();
      // FetchParish();
    }
  }, [TOKEN, currentPage, provinceName]);

  // useEffect(() => {
  //   if (TOKEN) {
  //     // fetchArea();
  //     fetchZone();
  //     // fetchContinents();
      
  //   }
  // }, []);

  const filteredData = tableData.filter(item => {
    const term = searchTerm.toLowerCase();
  
    return (
      (item.description?.toLowerCase().includes(term)) ||
      (item.created_at?.includes(term)) ||
      (item.updated_at?.includes(term))
    );
  });
  const startIndexx = (currentPage - 1) * entriesPerPage + 1;
  const totalEntries = filteredData.length;
const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);
// const displayedData = searchTerm : filteredData ? tableData;
const displayedData = searchTerm ? filteredData : tableData;

const totalPages = Math.ceil(filteredData.length / entriesPerPage);
const formattedTotalEntries = totalEntries.toLocaleString();

const handleZone = (selectedOption) => {
  setSelectedZone(selectedOption.value);
};
const handleArea = (selectedOption) => {
  setSelectedArea(selectedOption.value);
  // if (!selectedOption.value) {
  //   setFetchMode('default');
  //   fetchAll();
  // }
};




  const handleEyeClick = (id) => {
    const foundArea = tableData.find(item => item.id === id);
    setSelectedArea1(id);
    setDescription1(foundArea?.description || '');
    setSelectedZone1(foundArea?.zone?.id || '');
    setShow1(true);
    setEyeClicked(true);
  };

  const fetchZones = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL1}/zones`, {
        headers: {
          'Authorization': `Bearer ${TOKEN}`,
          'Content-Type': 'application/json'
      }, 
        
    });

    const res = response.data?.data?.zones;
    const opts = res.map((item) => ({
      label: item.description,
      value: item.id,
    }));
    setTableData4(opts);
    
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        // navigate('/login');
      }else{
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
                errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
                errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
                errorMessage = JSON.stringify(error.response.data.message);
            }
        }
      setTableData4([]);
    }
    console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (TOKEN) {
      // fetchAreas();
      fetchZones();
    
    }
  }, [TOKEN]);



  const handleTrashClick = async (id) => {
    const confirmResult = await Swal.fire({
      title: 'Are you sure?',
      text: 'You are about to delete this area. This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    });

    if (confirmResult.isConfirmed) {
    try {
      const response = await axios.get(`${BASE_URL1}/areas/delete_area?id=${id}`,  {
          headers: {
            'Authorization': `Bearer ${TOKEN}`,
            'Content-Type': 'application/json'
        }, 
     });
      fetchArea();
      // handleProcess();

      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      setTrashClicked(true);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                if (typeof error.response.data.message === 'string') {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join('; ');
                } else if (typeof error.response.data.message === 'object') {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
                // toast.error(errorMessage);
                Swal.fire({
                  icon: 'error',
                  title: 'Failed',
                  text: errorMessage,
                });
            }
    }
  } else {
     
    Swal.fire({
      icon: 'info',
      title: 'Cancelled',
      text: 'The deletion was cancelled.',
    });
  }
  };

  // React Select styles
  const selectStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',
      fontSize: 12,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "36px",
      fontSize: 12,
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: 12,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
      color: "#111827",
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "300px",
      overflowY: "auto",
      fontSize: 12,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handleViewFixed = async (id,name) => {
    setSelectedItemId(id);
    setViewLoading(true);
    console.log(id)
    try {
      const response = await axios.get(`${BASE_URL1}/fixedassets/get-by-type?parish_id=${id}`,

        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${TOKEN}`
          }
        });

      const instructionData1 = response.data?.data?.assets?.data;
      setResponseData(instructionData1);
      const resultx = response.data?.data?.assets?.total;
      // setTotalEntries(resultx);
      const total = response.data?.data?.assets?.last_page || 1;
      // setTotalPages(total);
      console.log(instructionData1, "Am here")

      navigate('/fixed_assets_register', { state: { parishID: id,name } });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

    } finally {
      setViewLoading(false);
    }
  }

  const editContinent = async () => {
    setCreateLoading(true);
    // setLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL1}/areas/update_area`,  
        {
          description: description1,
          // zone_id: selectedZone.value || '',
          id: selectedArea1 
        },
        {
          headers: {
            'Authorization': `Bearer ${TOKEN}`, 
            'Content-Type': 'application/json',
          },
        }
      );
      
      fetchArea();
      handleClose1();
  
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      
      // Check and handle specific error message
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        // toast.error(errorMessage);
        console.log(errorMessage);
      }
    } finally {
      setCreateLoading(false);
    }
  };

  return (
    <div>
      <HeaderNav />

      {/* Create User Modal */}
      <Modal show={showCreateUserModal} onHide={handleCloseCreateUserModal} >
        <Modal.Header closeButton>
        <Modal.Title>Add Area</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form style={{ marginTop: 20 }}>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Zone</Form.Label>
                            <Select
                                      onChange={(selectedOption) => handleZone(selectedOption)}
                                      options={zones}
                                          // value={selectedZone}
                                          menuPortalTarget={document.body}
                                          styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            menu: (provided) => ({
                                              ...provided,
                                              maxHeight: '300px',
                                              maxWidth: '100%',
                                              overflowY: 'auto',
                                            }),
                                          }}
                                        />
                            <Form.Label style={{marginTop: "20px"}}>Description</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Description"
                              // autoFocus
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                            />
                            
                          </Form.Group>
                        </Form>
                      </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseCreateUserModal}>Cancel</Button>
          <Button
            className={classes.createUserButton}
            onClick={createZones}
            variant="primary"
          >
            {createLoading ? (
                      <>
                      <Spinner  size='sm' /> 
                      <span style={{ marginLeft: '5px' }}>Creating Area, Please wait...</span>
    </>
  ) : (
                "Create Area"
                      )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit User Modal */}
       <Modal show={show1} onHide={handleClose1} animation={false}>
                      <Modal.Header closeButton>
                        <Modal.Title>Edit Area</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form style={{ marginTop: 20 }}>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          {/* <Form.Label>Zone</Form.Label>
                          <Select
                                          onChange={setSelectedZone1}
                                          options={tableData4}
                                          value={selectedZone1}
                                          menuPortalTarget={document.body}
                                          styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            menu: (provided) => ({
                                              ...provided,
                                              maxHeight: '300px',
                                              maxWidth: '100%',
                                              overflowY: 'auto',
                                            }),
                                          }}
                                        /> */}
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Description"
                              // autoFocus
                              value={description1}
                              onChange={(e) => setDescription1(e.target.value)}
                            />
                            
                          </Form.Group>
                        </Form>
                      </Modal.Body>






                              <Modal.Footer>
                                <Button variant="danger" onClick={handleClose1}>
                                  Go back
                                </Button>
                                <Button onClick={editContinent} >
                                  {createLoading ? ( <> <Spinner  size='sm' />
                                    <span style={{ marginLeft: '5px' }}>
                                      Editing Area, Please wait...
                                    </span>
                                    </>) : ("Save Changes")}
                                </Button>
                               

                               
                            </Modal.Footer>
                          </Modal>

      {/* Main Content */}
      <div className={classes.topContainer}>
        {/* <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Remittances</Button>
          <Button className={classes.buttonsNav}>Petty Cash</Button>
          <Button className={classes.buttonsNav}>Supplier's Payment</Button>
          <Button className={classes.buttonsNav}>Customer's Ledger</Button>
        </div> */}

        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Manage Areas
        </h3>
        <p className={classes.prgText}>Add, View, Edit, and Delete Areas</p>


        <div 
  className={classes.subContainer} 
  style={{ 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center',
    marginBottom: '-17px',
    marginTop: '30px'
  }}
>
  {/* LEFT SECTION */}
  <div style={{ display: 'flex', gap: '15px', flex: 1 }}>
  {/* <div style={{ minWidth: '200px' }}>
             
              <Select
                  onChange={(selectedOption) => handleZone(selectedOption)}
                  options={zones}
                placeholder="Select Zone"
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div> */}

            {/* <Button
                                style={{ borderRadius: 5, marginLeft: "10px", background: "#092147", whiteSpace: "nowrap"  }} onClick={handleProcess}>
                                {processLoading ? (
                                  <>
                                    <Spinner size='sm' />
                                    <span style={{ marginLeft: '5px' }}>Processing, Please wait...</span>
                                  </>
                                ) : (
                                  "Process"
                                )}
                              </Button> */}
  </div>

  {/* CENTER SECTION */}
  <div style={{ display: 'flex', justifyContent: 'center', flex: 1 }}>
    <button className={classes.loanBtn} onClick={handleShowCreateUserModal}>
      <img src={plus} alt="plus" /> Add Area
    </button>
  </div>

  {/* RIGHT SECTION */}
  <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', position: "relative", left: "140px" }}>
    <div className={classes.searchInputWrapper}>
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className={classes.searchInput}
        placeholder="Search areas..."
      />
      <Search className={classes.searchIcon} size={16} />
      {searchLoading && (
        <div className={classes.searchSpinner}>
          <Spinner animation="border" size="sm" style={{ width: '16px', height: '16px' }} />
        </div>
      )}
    </div>
  </div>
</div>


        <div style={{ marginTop: 24 }} />

        <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>#</th>
                  <th>Areas</th>
                    <th>Created At</th>
                    <th>Updated At</th>
                    {/* <th>Province</th> */}
                   {/* <th>Area</th>
                  <th>Zone</th> */}
                    <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {areaLoad ? (
                <SkeletonLoader />
              ) :  displayedData.length > 0 ? (
                 displayedData.map((item, index) => (
                  <tr style={{fontSize: "12px"}} key={item.id || index}>
                    
                  <td>{index + 1}</td>
                                                <td>{item.description}</td>
                                                <td>{formatDate(item.created_at)}</td>
                                                <td>{formatDate(item.updated_at)}</td>
                
                                                <td style={{display: "flex", gap: "10px"}}>
                                                  
                                                <button 
                                                style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
                                                onClick={() => handleEyeClick(item.id)} 
                                                >
                                                 <img src={EyeIcon} />
                                          </button>
                                          <button 
                                          onClick={() => handleTrashClick(item.id)} 
                                          style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
                                          >
                                           <img src={DeleteIcon} />
                                          </button>
                          
                                                 

                                                </td>
                  </tr>
                ))
              ) : (
                <tr style={{fontSize: "12px"}}>
                  <td colSpan="7" className="text-center p-4" style={{ color: '#6c757d' }}>
                    {searchTerm ? `No area found matching "${searchTerm}"` : "No area available."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className={classes.paginationStyle}>
          <div className={classes.footerSubOne}>
            <button
              className={classes.btnFirst}
              onClick={handleFirstPage}
              disabled={currentPage === 1}
            >
              First
            </button>
            <span className={classes.ftOne}>
              {getPageNumbers().map(pageNum => (
                <button
                  key={pageNum}
                  className={`${classes.pageNumber} ${currentPage === pageNum ? classes.active : ''}`}
                  onClick={() => handlePageClick(pageNum)}
                >
                  {pageNum}
                </button>
              ))}
            </span>
            <button
              className={classes.btnSec}
              onClick={handleLastPage}
              disabled={currentPage === totalPages}
            >
              Last
            </button>
          </div>
          <p className={classes.displayPag}>
            Displaying {(currentPage - 1) * perPage + 1}-{Math.min(currentPage * perPage, totalUsers)} of {totalUsers} users
          </p>
        </div>
      </div>
    </div>
  )
}

export default FixedAssetArea;